var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.486 1a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-2v1.042c2.895.245 4.947 1.552 6.258 3.203 1.421 1.79 1.958 3.974 1.782 5.56-.006.059 0 .085.002.088l.78 1.82a2 2 0 0 1-1.839 2.787h-7.983a1 1 0 0 1-.25-.032 1 1 0 0 1-.25.032H2.002a2 2 0 0 1-1.838-2.788l.78-1.819c0-.003.007-.03 0-.088-.175-1.585.362-3.77 1.784-5.56C4.112 4.5 6.325 3.14 9.486 3.01V2h-2a1 1 0 0 1-1-1Zm3.5 4C7.168 5 5.372 6.13 4.294 7.488c-.922 1.162-1.33 2.503-1.377 3.514L2.986 11h14.568c-.048-1.011-.456-2.35-1.377-3.512C15.1 6.13 13.303 5 10.486 5h-.5Zm7.84 8H2.986a.998.998 0 0 1-.319-.052L2.002 14.5h7.984a1 1 0 0 1 .25.031 1 1 0 0 1 .25-.031h7.983l-.643-1.5Z",
    fill: "#51BB7B"
  })));
};
export default SvgBell;